export default "__VITE_ASSET__DY14$sM5__"